<template>
    <div class="frame" v-if="!isSingePage">
        <el-container>
            <el-aside width="300px">
                <menu-nav/>
            </el-aside>

            <el-container>
                <el-header height="100px">
                    <project-header/>
                </el-header>

                <el-main :class="{'el-main-bg': $route.name != 'index'}">
                    <keep-alive :max="20">
                        <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
                </el-main>

                <el-footer height="38px"><span>技术支持：青岛房宜美数据科技有限公司 &nbsp;&nbsp;&nbsp;&nbsp;客服电话：0532-58552955</span> &nbsp;&nbsp;&nbsp;&nbsp;<a href="/static/pdf/instructions_pc.pdf" style="color: #4b9fe8;" target="_blank">系统操作说明</a></el-footer>

            </el-container>
        </el-container>
    </div>
</template>

<script>
    import menuNav from '@/components/menuNav'
    import projectHeader from '@/components/projectHeader'

    export default {
        name: "frame",
        components: {
            menuNav, projectHeader
        },
        data () {
            return {}
        }
    };

</script>

<style scoped>
    .frame {
        height: 100%;
    }

    .el-container {
        height: 100%;
        background: url("~@/assets/images/main_bg.jpg") no-repeat;
        background-size: 100% 100%;
    }

    .el-header {
        color: #333;
        padding: 0;
    }

    .el-aside {
        color: #333;
        background-color: #2e4467;
    }

    .el-main {
        padding: 20px 50px;
    }

    .el-footer {
        color: #fff;
        font-size: 12px;
        line-height: 38px;
        text-align: center;
        background-color: #2e4467;
    }

    .el-main-bg {
        background-color: #f7f7f7;
    }
</style>



// WEBPACK FOOTER //
// src/components/frame.vue